import { PracticeView } from "@/shared/modules/typescript-trust-ti-api-client/models/practice-view";
import { GenerateNextYearTrustComplianceForm } from "@/shared/modules/typescript-trustapi-client/models";
import { Options, Prop, Vue, Watch } from "vue-property-decorator";

@Options({})
export default class GenerateNextYearComplianceModel extends Vue {


  @Prop({ default: false })
  private modalOpened!: boolean;

  @Prop({ default: null })
  private selectedPractice!: PracticeView;

  @Prop({ default: null })
  private complianceForm!: 	GenerateNextYearTrustComplianceForm;

  @Watch('modalOpened')
  private onModalOpenedChanged(): void {
    if (this.modalOpened) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }

  mounted() {
    if (this.modalOpened) {
      document.body.classList.add('modal-open');
    }
  }

  beforeUnmount() {
    if (this.modalOpened) {
      document.body.classList.remove('modal-open');
    }
  }

  private closeModal(): void {
    this.$emit('close');
  }

  private confirmModal(): void {
    this.$emit('confirmed');
  }

  get nextYear(): string {
    return this.complianceForm?.complianceYear?.name || '';
  }

}

